import React from "react"
import {
  Col,
  Card,
  Label,
  Button,
  CardBody,
  CardTitle,
  FormGroup
} from "reactstrap"
import noImage from "assets/images/no-image.jpg"
import ProductPrice from "./ProductPrice"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const ProductCard = ({ item, setRef, selectOption, onAddToCartClick }) => {
  return (
    <Col lg={4} md={6} sm={6} xs={12} className="mb-3 product-col">
      <Card className="product-card">
        <div className="card-header product-img ">
          <div
            className="img-div"
            style={{
              backgroundImage: `${
                item.photoUrl
                  ? `url(http://${item.photoUrl})`
                  : `url(${noImage})`
              }`,
              cursor: "pointer"
            }}
            onClick={() => {
              window.location.href = `#/product/detail/${item.id}`
            }}
          />
        </div>

        <CardBody className="d-flex flex-column justify-content-between">
          <CardTitle>
            <h4>{item.name}</h4>
            <p>產品編號：{item.productNumber}</p>
            <p>
              商品價格：
              <ProductPrice price={item.price} />
            </p>
          </CardTitle>
          <div className="operation-block ">
            <FormGroup>
              <Label for="exampleSelect">商品數量</Label>
              <select
                className="form-control"
                ref={ref => {
                  setRef(ref, item.id)
                }}
              >
                {selectOption()}
              </select>
            </FormGroup>
            <div className="d-flex">
              <Button
                color="success"
                outline
                className="mr-1"
                onClick={onAddToCartClick}
              >
                <i className="ti-shopping-cart" style={{ fontSize: "16px" }} />
              </Button>
              <Button
                color="success"
                block
                onClick={() => {
                  window.location.href = `#/product/detail/${item.id}`
                }}
              >
                查看商品
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default ProductCard
